import React, { useState } from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import { trainingInfoArr } from "../../context/training.context";
import TrainingCard from "../training-card/training-card";
import skillsImage from "../../assets/skills.png";
import "./training-preview-module.css";

export default function TrainingPreviewModule(props: any) {
  const [hideParagraph, setHideParagraph] = useState<boolean>(false);

  const handleCardClick = () => {
    if (props.fromPage) {
      setHideParagraph(true);
    }
  };

  return (
    <ScrollAnimation animateIn="fadeIn" initiallyVisible={props.fromPage ? true : false}>
      <div className={`${props.fromPage ? "-light-theme" : "-dark-theme"}`}>
        <div className="ae-page-container">
          <h2 className={`h1 ae-training-preview-module-title ${props.fromPage ? "-light-theme -hidden" : "-dark-theme"}`}>
            Training Courses
          </h2>
          <div
            className="ae-training-preview-module-container"
          >
            <div className="ae-training-preview-module-intro">
              <p
                className={`ae-training-preview-module-intro-text ${
                  hideParagraph ? "-hidden" : "-visible"
                }`}
              >
                At <b>ActEd.</b>, we specialise in developing presence through
                vocal, body language, and communication coaching. As trained actors
                and <b>educational specialists</b>, we bring a unique blend of
                performance expertise and professional training, with extensive
                experience mentoring, coaching, and training teachers and
                professionals across diverse settings.
                <br />
                <br />
                What sets us apart is our ability to improvise and role-play,
                enabling us to deliver <b>interactive</b>, practical workshops. Our
                innovative ‘flight simulator’ approach gives you the chance to ‘have
                a go’ and put the skills you learn into practice in a{" "}
                <b>supportive</b>, fun environment.
              </p>
              <img className="ae-training-preview-module-intro-image" src={skillsImage} alt=""/>
            </div>
              <div className="ae-training-preview-module-card-container">
                {trainingInfoArr.map((training) => (
                  <TrainingCard
                    title={training.title}
                    heading={training.heading}
                    url="/training-detail"
                    paragraph={training.paragraph}
                    preview={training.preview}
                    image={training.img}
                    subcategories={training.subcategories}
                    key={training.key}
                    handleClick={handleCardClick}
                    fromPage={props.fromPage}
                  />
                ))}
              </div>
          </div>
        </div>
      </div>
    </ScrollAnimation>
  );
}
